export default "__VITE_ASSET__My1gAIN2__"